// RUTA: src/components/ExpandingCard/ExpandingCard.styles.ts

import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const variables = {
  borderRadius: '16px',
  borderColor: '#e9ecef',
  white: '#ffffff',
  primary: '#007bff',
  text: '#343a40',
  textLight: '#6c757d',
  shadow: '0 4px 4px rgba(0, 0, 0, 1)',
  shadowHeavy: '0 12px 35px rgba(0, 0, 0, 0.25)',
};
// Contenedor principal de la tarjeta (sin cambios)
export const CardWrapper = styled(motion.div)<{
  isOtherFocused?: boolean;
  hasInteraction?: boolean;
}>`
  position: relative;
  background-color: ${variables.white};
  border-radius: ${variables.borderRadius};
  padding: clamp(16px, 4vw, 24px); // clamp() ya es responsivo, excelente.
  box-shadow: ${variables.shadow};
  border: 2px solid transparent; 
  cursor: pointer;
  transition: opacity 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease;
  overflow: hidden;
  
  // ✅ CAMBIO CLAVE: Se reemplaza la altura en porcentaje por una altura fija y adaptable.

  opacity: ${({ isOtherFocused, hasInteraction }) =>
    isOtherFocused && hasInteraction ? 0.4 : 1};

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: ${variables.borderRadius};
    border: 2px solid ${variables.primary};
    clip-path: circle(0% at 50% 50%);
    transition: clip-path 0.4s ease-in-out;
    z-index: 0;
    pointer-events: none;
  }

  &:hover::before {
    clip-path: circle(75% at 50% 50%);
  }

  & > * {
    position: relative;
    z-index: 1;
  }
  
  // ✅ CAMBIO CLAVE: Se ajusta la altura para tabletas y móviles.
  @media (max-width: 768px) {
    height: 220px;
  }

  @media (max-width: 480px) {
    height: 200px;
  }
`;

// Contenedor para el ícono y el título principal (sin cambios)
export const CardHeader = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

// Estilo para el título principal (sin cambios)
export const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
`;

// Contenedor para la cuadrícula de sub-ítems
export const SubItemsGrid = styled(motion.div)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* ✅ Aumentamos el espacio entre los botones */
  gap: 14px; 
  width: 100%;
  margin-top: 2rem;
`;

// Estilo para cada uno de los 10 catálogos
export const SubItem = styled(Link)`
  background: #f8f9fa;
  border-radius: 8px;
  text-decoration: none;
  color: #495057;
  font-weight: 500;
  font-size: 0.9rem;
  transition: background 0.2s ease, color 0.2s ease;

  /* ✅ Centramos el texto perfectamente y aseguramos un espaciado uniforme */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 8px; /* Un poco más de espacio vertical */
  min-height: 40px;   /* Altura mínima para que todos se vean parejos */
  

  &:hover {
    background: #007bff;
    color: white;
  }
`;